export default __webpack_public_path__ + "static/media/react.003106ff.svg";